import Help from "./Help";
export default Help;
